module.exports = "<span *ngIf=\"!loaded && !error\"><i class=\"fa fa-spinner fa-pulse fa-fw\"></i></span>\r\n<span *ngIf=\"error\"><i title=\"Cannot generate thumbnail right now. Try again later.\" class=\"fa fa-warning fa-fw\"></i></span>\r\n\r\n<div [hidden]=\"!loaded\">\r\n\t<img (error)=\"error = true\" (load)=\"loaded = true\" [src]=\"imgSrc\" style=\"{{imgStyle}}\" class=\"{{imgClass}}\" />\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./TypeScript/shared/components/image-loader.component.html
// module id = 383
// module chunks = 10